var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tmDraggable",staticClass:"draggable",class:[_vm.isMultipleComponent && 'multipleClass'],style:(_vm.TmDraggableStyle),on:{"mouseenter":_vm.handleMouseEnter,"mouseleave":_vm.handleMouseLeave,"click":function($event){$event.stopPropagation();return _vm.handleClickDraggable($event)},"contextmenu":_vm.handleContextMenu}},[_c('div',{staticClass:"component-wrapper"},[_vm._t("default")],2),(!_vm.preview)?_c('div',{ref:"leftTop",style:(_vm.conf.type !== 'TumengPriceTag' && _vm.conf.type !== 'TumengAd'
        ? _vm.leftTopCircle
        : _vm.defalutCircle)}):_vm._e(),(!_vm.preview)?_c('div',{ref:"rightTop",style:(_vm.conf.type !== 'TumengPriceTag' && _vm.conf.type !== 'TumengAd'
        ? _vm.rightTopCircle
        : _vm.defalutCircle)}):_vm._e(),(!_vm.preview)?_c('div',{ref:"leftBottom",style:(_vm.conf.type !== 'TumengPriceTag' && _vm.conf.type !== 'TumengAd'
        ? _vm.leftBottomCircle
        : _vm.defalutCircle)}):_vm._e(),(!_vm.preview)?_c('div',{ref:"rightBottom",style:(_vm.conf.type !== 'TumengPriceTag' && _vm.conf.type !== 'TumengAd'
        ? _vm.rightBottomCircle
        : _vm.defalutCircle)}):_vm._e(),(!_vm.preview)?_c('div',{ref:"top",style:(_vm.conf.type !== 'TumengPriceTag' &&
      _vm.conf.type !== 'TumengAd' &&
      _vm.conf.type !== 'TumengQRCode'
        ? _vm.topCircle
        : _vm.defalutCircle)}):_vm._e(),(!_vm.preview)?_c('div',{ref:"rightMiddle",style:(_vm.conf.type !== 'TumengPriceTag' &&
      _vm.conf.type !== 'TumengAd' &&
      _vm.conf.type !== 'TumengQRCode'
        ? _vm.rightMiddleCircle
        : _vm.defalutCircle)}):_vm._e(),(!_vm.preview)?_c('div',{ref:"bottom",style:(_vm.conf.type !== 'TumengPriceTag' &&
      _vm.conf.type !== 'TumengAd' &&
      _vm.conf.type !== 'TumengQRCode'
        ? _vm.bottomCircle
        : _vm.defalutCircle)}):_vm._e(),(!_vm.preview)?_c('div',{ref:"leftMiddle",style:(_vm.conf.type !== 'TumengPriceTag' &&
      _vm.conf.type !== 'TumengAd' &&
      _vm.conf.type !== 'TumengQRCode'
        ? _vm.leftMiddleCircle
        : _vm.defalutCircle)}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }